import React, { useEffect, useState } from 'react';
import ApiService from '../../utils/ApiService';
import { Box, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import ComboBox from '../autoComplete/ComboBox';
import { useSelector } from 'react-redux';
import UserListComboBox from '../autoComplete/UserListComboBox';
import { useLocation } from 'react-router-dom';
import { identifierType } from '../TypeComponent';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function PurposeComponent(props) {
    const query = useQuery();
    const source = query.get('source');
    const purpose = query.get('purpose');

    const [purposeList, setPurposeList] = useState([])
    const [selectedPurpose, setSelectedPurpose] = useState(null);
    const userSkillList = useSelector(state => state?.user?.userListName?.skills)
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedSkills, setSelectedSkills] = useState([]);
    const [purposeBoxDisabledStatus, setPurposeBoxDisabledStatus] = useState(false);
    const usersList = useSelector(state => state?.allUsersList?.allUsers)

    useEffect(function () {

        ApiService.get('genaiPromptCategory').then(response => {
            // console.debug("GenAi : PurposeComponent : genaiPromptCategory : response.data.data : ", response.data.data);
            // setLoadingPurposeList(false)
            let pData = response.data.data.map(m => {
                return { label: m.name, ...m }
            });
            setPurposeList(pData);
            if (purpose) {
                const match = pData.find(item => item.identifier === purpose);
                if (match) {
                    // console.debug("GenAi : PurposeComponent : genaiPromptCategory : match : ", match);
                    setSelectedPurpose(match);
                    setPurposeBoxDisabledStatus(true);
                }

            }
        }).catch((error) => {
            // setLoadingPurposeList(false)
            // dispatch(openSnackbar({ dataLoad: true, message: error.message, severity: "error" }));
            console.error(error)
        })

    }, []);

    function purposeComboBoxOnChangeHandler(item) {
        // console.debug("genAI : PurposeComponent : purposeComboBoxOnChangeHandler : ComboBox : onChangeHandler : item : ", item);
        setSelectedPurpose(item);
        setSelectedUser(null);
        setSelectedSkills([]);
        if (props?.purposeChangeHandler) {
            props.purposeChangeHandler(item);
        }
    }

    function userComboBoxOnChangeHandler(item) {
        // console.debug("genAI : PurposeComponent : userComboBoxOnChangeHandler : ComboBox : onChangeHandler : item : ", item);
        setSelectedUser(item);
        if (props?.userChangeHandler) {
            props.userChangeHandler(item);
        }
    }
    function skillComboBoxOnChangeHandler(items) {
        // console.debug("genAI : skillComboBoxOnChangeHandler : ComboBox : onChangeHandler : item : ", item);
        setSelectedSkills(items);
        if (props?.skillChangeHandler) {
            props.skillChangeHandler(items);
        }
    }




    // function getOptionalComponentProps() {
    //     let componentProps = {};

    //     if (selectedPurpose?.identifier == identifierType().dailyPost) {
    //         componentProps.options = userSkillList?.map(u => { return { label: u?.skill, ...u } });
    //         componentProps.onChangeHandler = skillComboBoxOnChangeHandler;
    //         // componentProps.multiple = false;
    //         componentProps.multiple = true;
    //         // componentProps.value=selecte
    //     } else {
    //         componentProps.options = usersList?.map(u => { return { label: u?.userName, ...u } });
    //         componentProps.onChangeHandler = userComboBoxOnChangeHandler;
    //         componentProps.multiple = false;
    //     }
    //     return componentProps;
    // }

    return (
        <Box>
            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                <Grid item xs={12} md={6}>
                    <ComboBox
                        options={purposeList}
                        onChangeHandler={purposeComboBoxOnChangeHandler}
                        multiple={false}
                        // multiple={true}
                        optionKey={"id"}
                        defaultValue={selectedPurpose}
                        disabled={purposeBoxDisabledStatus}
                        headKey={'Select Purpose'}

                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    {

                        (selectedPurpose?.identifier == identifierType().dailyPost)
                            ?
                            <ComboBox
                                options={userSkillList?.map(u => { return { label: u?.skill, ...u } })}
                                onChangeHandler={skillComboBoxOnChangeHandler}
                                multiple={true}
                                optionKey={"skillId"}
                                headKey={'Select Skills'}
                            />
                            :
                            ""
                    }
                    {

                        (selectedPurpose?.identifier && selectedPurpose.identifier !== identifierType().dailyPost)
                            ?

                            < ComboBox
                                options={usersList?.map(u => { return { label: u?.userName, ...u } })}
                                onChangeHandler={userComboBoxOnChangeHandler}
                                multiple={false}
                                optionKey={"userId"}
                                headKey={'Select Employees'}
                            />
                            :
                            ""
                    }
                </Grid>
            </Box>

        </Box>
    );
}

export default PurposeComponent;